<template>
  <div style="position: fixed;z-index: 2000;" class="anima">
    <img style="width: 100vw;height: calc(100vh - 50px)" src="../assets/bg-2.jpg" />
  </div>
</template>

<script>
export default {
  data() {
    return {
      timer: '',
    }
  },
  methods: {
    goToMainPage() {
      this.$router.push('/jobinfo')
      document.getElementsByClassName('footer')[0].style.display = 'block'
      clearInterval(this.timer)
    },
  },
  mounted() {
    document.getElementsByClassName('footer')[0].style.display = 'none'
    this.timer = setInterval(this.goToMainPage, 2800)
  },
  beforeDestroy() {
    document.getElementsByClassName('footer')[0].style.display = 'block'
    clearInterval(this.timer)
  },
}
</script>

<style>
@keyframes fadeOut {
  from {
    opacity: 1;
  }

  to {
    opacity: 0;
  }
}

.anima {
  animation: fadeOut 4s;
  animation-fill-mode: forwards;
  -webkit-animation-fill-mode: forwards;
}
</style>
